<template>
  <div>
    <a
      class="file-link md-layout-item md-size-80 md-large-size-30 mx-auto"
      @click="download(pdf)"
      style="cursor: pointer"
      v-if="pdf"
    >
      <md-icon>file_copy</md-icon>
      <md-tooltip md-direction="top" class="file-tooltip"> Subido </md-tooltip>
      PDF
    </a>
    <a
      class="file-link md-layout-item md-size-80 md-large-size-30 mx-auto"
      @click="download(xml)"
      style="cursor: pointer"
      v-if="xml"
    >
      <md-icon>file_copy</md-icon>
      <md-tooltip md-direction="top" class="file-tooltip"> Subido </md-tooltip>
      XML
    </a>
  </div>
</template>

<script>
import {downloadFile} from '../../../utils'

export default {

  name: 'freightFiles',

  props: {
    xml: String,
    pdf:String,
    invoice_number: String,
  },

  data() {
    return {
    };
  }, 
  methods: {
      download(url) {
        const win = window.open(url, "_blank");
        win.focus();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/Purchases/Freight/FreightFiles.vue